import React, { FC } from "react";
import { StatusMessage } from "./StatusMessage";
import { StatusRendererProps } from "../../../components/Overlay";
import { SIDE } from "_constants";
import { getActiveTeamName } from "../utils";

export const BaseballStatusRenderer: FC<StatusRendererProps> = ({
  message,
  side,
  homeTeam,
  awayTeam,
  normalizedCode,
  activeTeam,
  status,
  language,
  Icon,
  description,
  width,
  height,
}) => {
  const sideEnum: SIDE = (() => {
    const s: any = side;
    if (typeof s === "string") {
      return s.toLowerCase() === "away" ? SIDE.AWAY : SIDE.HOME;
    }
    if (s === SIDE.AWAY || s === SIDE.HOME) return s as SIDE;
    return SIDE.HOME;
  })();

  const teamForStatusMessage = activeTeam ?? getActiveTeamName(status);

  return (
    <>
      {normalizedCode && (
        <StatusMessage
          title={message}
          normalizedCode={normalizedCode as any}
          team={teamForStatusMessage}
          side={sideEnum}
          Icon={Icon}
          status={status}
          width={width}
          height={height}
          description={description}
        />
      )}
    </>
  );
};
